import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const reset = () => null;

/**
 *
 * @param {string} _
 * @param {import('modules/statistics/types').FetchCustomerOpinionStatsFailureAction} action
 * @returns {string}
 */
const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_CUSTOMER_OPINION_STATS_REQUEST]: reset,
  [types.FETCH_CUSTOMER_OPINION_STATS_FAILURE]: setError,
});
